import Color from '@bubble-dev/fantasy-color';
import { createConstantColor } from './helpers';
export var brandPancakeKlarnaPink = createConstantColor(new Color('#FFB3C7'));
export var brandPancakeKlarnaBlack = createConstantColor(new Color('#17120F'));
export var brandPancakeKlarnaWhite = createConstantColor(new Color('#FFFFFF'));
export var brandPancakeSmooothYellow = createConstantColor(new Color('#FFF673'));
export var brandPancakeSmooothYellowBlocks = createConstantColor(new Color('#FFF999'));
export var brandPancakeSmooothGreen = createConstantColor(new Color('#80FFA6'));
export var brandPancakeSmooothGreenBlocks = createConstantColor(new Color('#9EFFBB'));
export var brandPancakeSmooothBlue = createConstantColor(new Color('#73F5FF'));
export var brandPancakeSmooothBlueBlocks = createConstantColor(new Color('#99F8FF'));
export var brandPancakeVanilla = createConstantColor(new Color('#FFFAB0'));
export var brandPancakeVanillaLight = createConstantColor(new Color('#FFFCC9'));
export var brandPancakeMint = createConstantColor(new Color('#B8FFCC'));
export var brandPancakeMintLight = createConstantColor(new Color('#D1FFE0'));
export var brandPancakePool = createConstantColor(new Color('#B3F9FF'));
export var brandPancakePoolLight = createConstantColor(new Color('#CCFCFF'));
export var brandPancakeLavender = createConstantColor(new Color('#E9D6FF'));
export var brandPancakeLavenderLight = createConstantColor(new Color('#F0E3FF'));
export var brandPancakeSky = createConstantColor(new Color('#BDD5FF'));
export var brandPancakeSkyLight = createConstantColor(new Color('#D1E2FF'));
export var brandPancakePeach = createConstantColor(new Color('#FFD7AD'));
export var brandPancakePeachLight = createConstantColor(new Color('#FFE6CC'));
//# sourceMappingURL=pancakeBrandColors.js.map